// 直接导出变量和修改函数

export function setWarehouseWindowsBoolean(value) {
  localStorage.setItem('openedWindowsBoolean', value);
}

export function getWarehouseWindowsBoolean() {
  return localStorage.getItem('openedWindowsBoolean') 
        ? JSON.parse(localStorage.getItem('openedWindowsBoolean').toLowerCase()) 
        : true;
}